import { render } from "./EmailLoginForm.vue?vue&type=template&id=260472fa&scoped=true"
import script from "./EmailLoginForm.vue?vue&type=script&lang=js"
export * from "./EmailLoginForm.vue?vue&type=script&lang=js"

import "./EmailLoginForm.vue?vue&type=style&index=0&id=260472fa&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260472fa"]])

export default __exports__